import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="pt-32 pb-24 min-h-screen bg-transparent relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <div className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 font-semibold text-sm mb-6">Our Story</div>
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">Pioneering the Digital<br/><span className="text-blue-600">Frontier</span></h1>
          <p className="text-lg text-slate-600 leading-relaxed">
            We are a group of passionate technologists, designers, and strategists working together to build software that changes the way businesses operate. With years of experience across multiple verticals, our mission is to empower organizations through innovative technology.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 mt-20">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-10 rounded-3xl border border-slate-100 shadow-sm"
          >
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Vision</h3>
            <p className="text-slate-600 leading-relaxed">
              To be the globally recognized leader in custom software development, enabling enterprises and startups alike to achieve unparalleled efficiency and digital fluency in a fast-paced interconnected world.
            </p>
          </motion.div>
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-white p-10 rounded-3xl border border-slate-100 shadow-sm"
          >
            <h3 className="text-2xl font-bold text-slate-900 mb-4">Our Mission</h3>
            <p className="text-slate-600 leading-relaxed">
              To consistently deliver robust, secure, and scalable solutions tailored precisely to our clients' unique challenges, all while prioritizing a customer-centric and highly agile approach.
            </p>
          </motion.div>
        </div>

        {/* Why Choose Us Section */}
        <div className="mt-32">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">Why Choose <span className="text-blue-600">Businex</span></h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">We combine technical excellence with business acumen to deliver software that truly matters.</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <motion.div initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6 font-bold text-xl">1</div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Enterprise Security</h4>
              <p className="text-slate-600 leading-relaxed">Security isn't an afterthought. We build secure-by-design architectures compliant with global data protection standards.</p>
            </motion.div>
            <motion.div initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{delay: 0.1}} className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6 font-bold text-xl">2</div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Complete Transparency</h4>
              <p className="text-slate-600 leading-relaxed">No hidden fees, no black boxes. You get full visibility into our agile development process, codebases, and project timelines.</p>
            </motion.div>
            <motion.div initial={{opacity:0, y:20}} whileInView={{opacity:1, y:0}} viewport={{once:true}} transition={{delay: 0.2}} className="bg-slate-50 p-8 rounded-3xl border border-slate-100 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center mb-6 font-bold text-xl">3</div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">Proven Expertise</h4>
              <p className="text-slate-600 leading-relaxed">Our engineers are vetted top-tier talent with years of experience building scalable platforms for startups and Fortune 500s.</p>
            </motion.div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;
